import React from 'react';
import { LineEverywhere, BarEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data1 = [{
    "date": "03/29/2017 10:00",
    "value": 2
}, {
    "date": "03/29/2017 10:05",
    "value": 2.5
}, {
    "date": "03/29/2017 10:10",
    "value": 3
}, {
    "date": "03/29/2017 10:15",
    "value": 3.5
}, {
    "date": "03/29/2017 10:20",
    "value": 4
}, {
    "date": "03/29/2017 10:25",
    "value": 4.5
}, {
    "date": "03/29/2017 10:30",
    "value": 5
}, {
    "date": "03/29/2017 10:35",
    "value": 4.5
}, {
    "date": "03/29/2017 10:40",
    "value": 4
}, {
    "date": "03/29/2017 10:45",
    "value": 3.5
}, {
    "date": "03/29/2017 10:50",
    "value": 3
}, {
    "date": "03/29/2017 10:55",
    "value": 2.5
}, {
    "date": "03/29/2017 11:00",
    "value": 2
}, {
    "date": "03/29/2017 11:05",
    "value": 1.5
}, {
    "date": "03/29/2017 11:10",
    "value": 1
}, {
    "date": "03/29/2017 11:15",
    "value": 8
}, {
    "date": "03/29/2017 11:20",
    "value": 2
}, {
    "date": "03/29/2017 11:25",
    "value": 9
}, {
    "date": "03/29/2017 11:30",
    "value": 4.5
}, {
    "date": "03/29/2017 11:35",
    "value": 10
}, {
    "date": "03/29/2017 11:40",
    "value": 10
}, {
    "date": "03/29/2017 11:45",
    "value": 10
}, {
    "date": "03/29/2017 11:50",
    "value": 1
}, {
    "date": "03/29/2017 11:55",
    "value": 1
}, {
    "date": "03/29/2017 12:00",
    "value": 1
}, {
    "date": "03/29/2017 12:05",
    "value": 3.5
}, {
    "date": "03/29/2017 12:10",
    "value": 3
}, {
    "date": "03/29/2017 12:15",
    "value": 2.5
}, {
    "date": "03/29/2017 12:20",
    "value": 2
}, {
    "date": "03/29/2017 12:25",
    "value": 1.5
}, {
    "date": "03/29/2017 12:30",
    "value": 1
}, {
    "date": "03/29/2017 12:35",
    "value": 1.5
}, {
    "date": "03/29/2017 12:40",
    "value": 2
}, {
    "date": "03/29/2017 12:45",
    "value": 2.5
}, {
    "date": "03/29/2017 12:50",
    "value": 3
}, {
    "date": "03/29/2017 12:55",
    "value": 3.5
}, {
    "date": "03/29/2017 13:00",
    "value": 2
}, {
    "date": "03/29/2017 13:05",
    "value": 2
}, {
    "date": "03/29/2017 13:10",
    "value": 5
}, {
    "date": "03/29/2017 13:15",
    "value": 4
}, {
    "date": "03/29/2017 13:20",
    "value": 3
}, {
    "date": "03/29/2017 13:25",
    "value": 2
}, {
    "date": "03/29/2017 13:30",
    "value": 2
}, {
    "date": "03/29/2017 13:35",
    "value": 3
}, {
    "date": "03/29/2017 13:40",
    "value": 2
}, {
    "date": "03/29/2017 13:45",
    "value": 5
}, {
    "date": "03/29/2017 13:50",
    "value": 4
}, {
    "date": "03/29/2017 13:55",
    "value": 4
}, {
    "date": "03/29/2017 14:00",
    "value": 2
}, {
    "date": "03/29/2017 14:05",
    "value": 2
}, {
    "date": "03/29/2017 14:10",
    "value": 5
}, {
    "date": "03/29/2017 14:15",
    "value": 4
}, { //Something needs to be passed (at least date), then equalSpacing works. If not pass here, create object in WC side.
    "date": "03/29/2017 14:20"//,
    //"value": 3
}, {
    "date": "03/29/2017 14:25"// ,
    //"value": 2
}, {
    "date": "03/29/2017 14:30"//,
    //"value": 2
}, {
    "date": "03/29/2017 14:35"//,
    //"value": 3
}, {
    "date": "03/29/2017 14:40",
    "value": 2
}, {
    "date": "03/29/2017 14:45",
    "value": 5
}, {
    "date": "03/29/2017 14:50",
    "value": 4
}, {
    "date": "03/29/2017 14:55",
    "value": 2
}];

/*
const dataLine = [{
    "date": "03/29/2017 10:00",
    "value": 3.5
}, {
    "date": "03/29/2017 11:00",
    "value": 4
}, {
    "date": "03/29/2017 12:00",
    "value": 3
}, {
    "date": "03/29/2017 13:00",
    "value": 2
}, {
    "date": "03/29/2017 14:00",
    "value": 1,
    "event": true
}, {
    "date": "03/29/2017 15:00",
    "value": 3
},/*  Non collapsed needs date entry to show the gap. Collapsed needs this to be removed or change the object to another number when there is a gap.
{
    "date": "03/29/2017 16:00"
}, {
    "date": "03/29/2017 17:00",
    "value": 3.5
}, {
    "date": "03/29/2017 18:00",
    "value": 9
}, {
    "date": "03/29/2017 19:00",
    "value": 4
}, {
    "date": "03/29/2017 20:00",
    "value": 5
}, {
    "date": "03/29/2017 21:00",
    "value": 7
}, {
    "date": "03/29/2017 22:00",
    "value": 8
}, {
    "date": "03/29/2017 23:00",
    "value": 9.5
}, {
    "date": "03/29/2017 24:00",
    "value": 8
}, {
    "date": "03/30/2017 01:00",
    "value": 7
}, {
    "date": "03/30/2017 02:00",
    "value": 6
}, {
    "date": "03/30/2017 03:00",
    "value": 9
}, {
    "date": "03/30/2017 04:00",
    "value": 10
}, {
    "date": "03/30/2017 05:00",
    "value": 9
}, {
    "date": "03/30/2017 06:00",
    "value": 9
}];
*/
const data2 = [
    {
        "date": "12/11/2017 15:10",
        "value": 1
    },
    {
        "date": "12/11/2017 15:15",
        "value": 1
    },
    {
        "date": "12/11/2017 15:20",
        "value": 1
    },
    {
        "date": "12/11/2017 15:25",
        "value": 1
    },
    {
        "date": "12/11/2017 15:30",
        "value": 1
    },
    {
        "date": "12/11/2017 15:35",
        "value": 1
    },
    {
        "date": "12/11/2017 15:40",
        "value": 1
    },
    {
        "date": "12/11/2017 15:45",
        "value": 1
    },
    {
        "date": "12/11/2017 15:50",
        "value": 1
    },
    {
        "date": "12/11/2017 15:55",
        "value": 1
    },
    {
        "date": "12/11/2017 16:00",
        "value": 1
    },
    {
        "date": "12/11/2017 16:05",
        "value": 1
    },
    {
        "date": "12/11/2017 16:10",
        "value": 1
    },
    {
        "date": "12/11/2017 16:15",
        "value": 1
    },
    {
        "date": "12/11/2017 16:20",
        "value": 1
    },
    {
        "date": "12/11/2017 16:25",
        "value": 1
    },
    {
        "date": "12/11/2017 16:30",
        "value": 1
    },
    {
        "date": "12/11/2017 16:35",
        "value": 1
    },
    {
        "date": "12/11/2017 16:40",
        "value": 1
    },
    {
        "date": "12/11/2017 16:45",
        "value": 1
    },
    {
        "date": "12/11/2017 16:50",
        "value": 1
    },
    {
        "date": "12/11/2017 16:55",
        "value": 1
    },
    {
        "date": "12/11/2017 17:00",
        "value": 1
    },
    {
        "date": "12/11/2017 17:05",
        "value": 1
    },
    {
        "date": "12/11/2017 17:10",
        "value": 1
    },
    {
        "date": "12/11/2017 17:15",
        "value": 1
    },
    {
        "date": "12/11/2017 17:20",
        "value": 1
    },
    {
        "date": "12/11/2017 17:25",
        "value": 1
    },
    {
        "date": "12/11/2017 17:30",
        "value": 1
    },
    {
        "date": "12/11/2017 17:35",
        "value": 1
    },
    {
        "date": "12/11/2017 17:40",
        "value": 1
    },
    {
        "date": "12/11/2017 17:45",
        "value": 1
    },
    {
        "date": "12/11/2017 17:50",
        "value": 1
    },
    {
        "date": "12/11/2017 17:55",
        "value": 1
    },
    {
        "date": "12/11/2017 18:00",
        "value": 1
    },
    {
        "date": "12/11/2017 18:05",
        "value": 1
    },
    {
        "date": "12/11/2017 18:10",
        "value": 1
    },
    {
        "date": "12/11/2017 18:15",
        "value": 1
    },
    {
        "date": "12/11/2017 18:20",
        "value": 1
    },
    {
        "date": "12/11/2017 18:25",
        "value": 1
    },
    {
        "date": "12/11/2017 18:30",
        "value": 1
    },
    {
        "date": "12/11/2017 18:35",
        "value": 1
    },
    {
        "date": "12/11/2017 18:40",
        "value": 1
    },
    {
        "date": "12/11/2017 18:45",
        "value": 1
    },
    {
        "date": "12/11/2017 18:50",
        "value": 1
    },
    {
        "date": "12/11/2017 18:55",
        "value": 1
    },
    {
        "date": "12/11/2017 19:00",
        "value": 1
    },
    {
        "date": "12/11/2017 19:05",
        "value": 1
    },
    {
        "date": "12/11/2017 19:10",
        "value": 1
    },
    {
        "date": "12/11/2017 19:15",
        "value": 1
    },
    {
        "date": "12/11/2017 19:20",
        "value": 1
    },
    {
        "date": "12/11/2017 19:25",
        "value": 1
    },
    {
        "date": "12/11/2017 19:30",
        "value": 1
    },
    {
        "date": "12/11/2017 19:35",
        "value": 1
    },
    {
        "date": "12/11/2017 19:40",
        "value": 1
    },
    {
        "date": "12/11/2017 19:45",
        "value": 1
    },
    {
        "date": "12/11/2017 19:50",
        "value": 1
    },
    {
        "date": "12/11/2017 19:55",
        "value": 1
    },
    {
        "date": "12/11/2017 20:00",
        "value": 1
    },
    {
        "date": "12/11/2017 20:05",
        "value": 1
    },
    {
        "date": "12/11/2017 20:10",
        "value": 1
    },
    {
        "date": "12/11/2017 20:15",
        "value": 1
    },
    {
        "date": "12/11/2017 20:20",
        "value": 1
    },
    {
        "date": "12/11/2017 20:25",
        "value": 1
    },
    {
        "date": "12/11/2017 20:30",
        "value": 1
    },
    {
        "date": "12/11/2017 20:35",
        "value": 1
    },
    {
        "date": "12/11/2017 20:40",
        "value": 1
    },
    {
        "date": "12/11/2017 20:45",
        "value": 1
    },
    {
        "date": "12/11/2017 20:50",
        "value": 1
    },
    {
        "date": "12/11/2017 20:55",
        "value": 1
    },
    {
        "date": "12/11/2017 21:00",
        "value": 1
    },
    {
        "date": "12/11/2017 21:05",
        "value": 1
    },
    {
        "date": "12/11/2017 21:10",
        "value": 1
    },
    {
        "date": "12/11/2017 21:15",
        "value": 1
    },
    {
        "date": "12/11/2017 21:20",
        "value": 1
    },
    {
        "date": "12/11/2017 21:25",
        "value": 1
    },
    {
        "date": "12/11/2017 21:30",
        "value": 1
    },
    {
        "date": "12/11/2017 21:35",
        "value": 1
    },
    {
        "date": "12/11/2017 21:40",
        "value": 1
    },
    {
        "date": "12/11/2017 21:45",
        "value": 1
    },
    {
        "date": "12/11/2017 21:50",
        "value": 1
    },
    {
        "date": "12/11/2017 21:55",
        "value": 1
    },
    {
        "date": "12/11/2017 22:00",
        "value": 1
    },
    {
        "date": "12/11/2017 22:05",
        "value": 1
    },
    {
        "date": "12/11/2017 22:10",
        "value": 1
    },
    {
        "date": "12/11/2017 22:15",
        "value": 1
    },
    {
        "date": "12/11/2017 22:20",
        "value": 1
    },
    {
        "date": "12/11/2017 22:25",
        "value": 1
    },
    {
        "date": "12/11/2017 22:30",
        "value": 1
    },
    {
        "date": "12/11/2017 22:35",
        "value": 1
    },
    {
        "date": "12/11/2017 22:40",
        "value": 1
    },
    {
        "date": "12/11/2017 22:45",
        "value": 1
    },
    {
        "date": "12/11/2017 22:50",
        "value": 1
    },
    {
        "date": "12/11/2017 22:55",
        "value": 1
    },
    {
        "date": "12/11/2017 23:00",
        "value": 1
    },
    {
        "date": "12/11/2017 23:05",
        "value": 1
    },
    {
        "date": "12/11/2017 23:10",
        "value": 1
    },
    {
        "date": "12/11/2017 23:15",
        "value": 1
    },
    {
        "date": "12/11/2017 23:20",
        "value": 1
    },
    {
        "date": "12/11/2017 23:25",
        "value": 1
    },
    {
        "date": "12/11/2017 23:30",
        "value": 1
    },
    {
        "date": "12/11/2017 23:35",
        "value": 1
    },
    {
        "date": "12/11/2017 23:40",
        "value": 1
    },
    {
        "date": "12/11/2017 23:45",
        "value": 1
    },
    {
        "date": "12/11/2017 23:50",
        "value": 1
    },
    {
        "date": "12/11/2017 23:55",
        "value": 1
    },
    {
        "date": "12/12/2017 00:00",
        "value": 1
    },
    {
        "date": "12/12/2017 00:05",
        "value": 1
    },
    {
        "date": "12/12/2017 00:10",
        "value": 1
    },
    {
        "date": "12/12/2017 00:15",
        "value": 1
    },
    {
        "date": "12/12/2017 00:20",
        "value": 1
    },
    {
        "date": "12/12/2017 00:25",
        "value": 1
    },
    {
        "date": "12/12/2017 00:30",
        "value": 1
    },
    {
        "date": "12/12/2017 00:35",
        "value": 1
    },
    {
        "date": "12/12/2017 00:40",
        "value": 1
    },
    {
        "date": "12/12/2017 00:45",
        "value": 1
    },
    {
        "date": "12/12/2017 00:50",
        "value": 1
    },
    {
        "date": "12/12/2017 00:55",
        "value": 1
    },
    {
        "date": "12/12/2017 01:00",
        "value": 1
    },
    {
        "date": "12/12/2017 01:05",
        "value": 1
    },
    {
        "date": "12/12/2017 01:10",
        "value": 1
    },
    {
        "date": "12/12/2017 01:15",
        "value": 1
    },
    {
        "date": "12/12/2017 01:20",
        "value": 1
    },
    {
        "date": "12/12/2017 01:25",
        "value": 1
    },
    {
        "date": "12/12/2017 01:30",
        "value": 1
    },
    {
        "date": "12/12/2017 01:35",
        "value": 1
    },
    {
        "date": "12/12/2017 01:40",
        "value": 1
    },
    {
        "date": "12/12/2017 01:45",
        "value": 1
    },
    {
        "date": "12/12/2017 01:50",
        "value": 1
    },
    {
        "date": "12/12/2017 01:55",
        "value": 1
    },
    {
        "date": "12/12/2017 02:00",
        "value": 1
    },
    {
        "date": "12/12/2017 02:05",
        "value": 1
    },
    {
        "date": "12/12/2017 02:10",
        "value": 1
    },
    {
        "date": "12/12/2017 02:15",
        "value": 1
    },
    {
        "date": "12/12/2017 02:20",
        "value": 1
    },
    {
        "date": "12/12/2017 02:25",
        "value": 1
    },
    {
        "date": "12/12/2017 02:30",
        "value": 1
    },
    {
        "date": "12/12/2017 02:35",
        "value": 1
    },
    {
        "date": "12/12/2017 02:40",
        "value": 1
    },
    {
        "date": "12/12/2017 02:45",
        "value": 1
    },
    {
        "date": "12/12/2017 02:50",
        "value": 1
    },
    {
        "date": "12/12/2017 02:55",
        "value": 1
    },
    {
        "date": "12/12/2017 03:00",
        "value": 1
    },
    {
        "date": "12/12/2017 03:05",
        "value": 1
    },
    {
        "date": "12/12/2017 03:10",
        "value": 1
    },
    {
        "date": "12/12/2017 03:15",
        "value": 1
    },
    {
        "date": "12/12/2017 03:20",
        "value": 1
    },
    {
        "date": "12/12/2017 03:25",
        "value": 1
    },
    {
        "date": "12/12/2017 03:30",
        "value": 1
    },
    {
        "date": "12/12/2017 03:35",
        "value": 1
    },
    {
        "date": "12/12/2017 03:40",
        "value": 1
    },
    {
        "date": "12/12/2017 03:45",
        "value": 1
    },
    {
        "date": "12/12/2017 03:50",
        "value": 1
    },
    {
        "date": "12/12/2017 03:55",
        "value": 1
    },
    {
        "date": "12/12/2017 04:00",
        "value": 1
    },
    {
        "date": "12/12/2017 04:05",
        "value": 1
    },
    {
        "date": "12/12/2017 04:10",
        "value": 1
    },
    {
        "date": "12/12/2017 04:15",
        "value": 1
    },
    {
        "date": "12/12/2017 04:20",
        "value": 1
    },
    {
        "date": "12/12/2017 04:25",
        "value": 1
    },
    {
        "date": "12/12/2017 04:30",
        "value": 1
    },
    {
        "date": "12/12/2017 04:35",
        "value": 1
    },
    {
        "date": "12/12/2017 04:40",
        "value": 1
    },
    {
        "date": "12/12/2017 04:45",
        "value": 1
    },
    {
        "date": "12/12/2017 04:50",
        "value": 1
    },
    {
        "date": "12/12/2017 04:55",
        "value": 1
    },
    {
        "date": "12/12/2017 05:00",
        "value": 1
    },
    {
        "date": "12/12/2017 05:05",
        "value": 1
    },
    {
        "date": "12/12/2017 05:10",
        "value": 1
    },
    {
        "date": "12/12/2017 05:15",
        "value": 1
    },
    {
        "date": "12/12/2017 05:20",
        "value": 1
    },
    {
        "date": "12/12/2017 05:25",
        "value": 1
    },
    {
        "date": "12/12/2017 05:30",
        "value": 1
    },
    {
        "date": "12/12/2017 05:35",
        "value": 1
    },
    {
        "date": "12/12/2017 05:40",
        "value": 1
    },
    {
        "date": "12/12/2017 05:45",
        "value": 1
    },
    {
        "date": "12/12/2017 05:50",
        "value": 1
    },
    {
        "date": "12/12/2017 05:55",
        "value": 1
    },
    {
        "date": "12/12/2017 06:00",
        "value": 1
    },
    {
        "date": "12/12/2017 06:05",
        "value": 1
    },
    {
        "date": "12/12/2017 06:10",
        "value": 1
    },
    {
        "date": "12/12/2017 06:15",
        "value": 1
    },
    {
        "date": "12/12/2017 06:20",
        "value": 1
    },
    {
        "date": "12/12/2017 06:25",
        "value": 1
    },
    {
        "date": "12/12/2017 06:30",
        "value": 1
    },
    {
        "date": "12/12/2017 06:35",
        "value": 1
    },
    {
        "date": "12/12/2017 06:40",
        "value": 1
    },
    {
        "date": "12/12/2017 06:45",
        "value": 1
    },
    {
        "date": "12/12/2017 06:50",
        "value": 1
    },
    {
        "date": "12/12/2017 06:55",
        "value": 1
    },
    {
        "date": "12/12/2017 07:00",
        "value": 1
    },
    {
        "date": "12/12/2017 07:05",
        "value": 1
    },
    {
        "date": "12/12/2017 07:10",
        "value": 1
    },
    {
        "date": "12/12/2017 07:15",
        "value": 1
    },
    {
        "date": "12/12/2017 07:20",
        "value": 1
    },
    {
        "date": "12/12/2017 07:25",
        "value": 1
    },
    {
        "date": "12/12/2017 07:30",
        "value": 1
    },
    {
        "date": "12/12/2017 07:35",
        "value": 1
    },
    {
        "date": "12/12/2017 07:40",
        "value": 1
    },
    {
        "date": "12/12/2017 07:45",
        "value": 1
    },
    {
        "date": "12/12/2017 07:50",
        "value": 1
    },
    {
        "date": "12/12/2017 07:55",
        "value": 1
    },
    {
        "date": "12/12/2017 08:00",
        "value": 1
    },
    {
        "date": "12/12/2017 08:05",
        "value": 1
    },
    {
        "date": "12/12/2017 08:10",
        "value": 1
    },
    {
        "date": "12/12/2017 08:15",
        "value": 1
    },
    {
        "date": "12/12/2017 08:20",
        "value": 1
    },
    {
        "date": "12/12/2017 08:25",
        "value": 1
    },
    {
        "date": "12/12/2017 08:30",
        "value": 1
    },
    {
        "date": "12/12/2017 08:35",
        "value": 1
    },
    {
        "date": "12/12/2017 08:40",
        "value": 1
    },
    {
        "date": "12/12/2017 08:45",
        "value": 1
    },
    {
        "date": "12/12/2017 08:50",
        "value": 1
    },
    {
        "date": "12/12/2017 08:55",
        "value": 1
    },
    {
        "date": "12/12/2017 09:00",
        "value": 1
    },
    {
        "date": "12/12/2017 09:05",
        "value": 1
    },
    {
        "date": "12/12/2017 09:10",
        "value": 1
    },
    {
        "date": "12/12/2017 09:15",
        "value": 1
    },
    {
        "date": "12/12/2017 09:20",
        "value": 1
    },
    {
        "date": "12/12/2017 09:25",
        "value": 1
    },
    {
        "date": "12/12/2017 09:30",
        "value": 1
    },
    {
        "date": "12/12/2017 09:35",
        "value": 1
    },
    {
        "date": "12/12/2017 09:40",
        "value": 1
    },
    {
        "date": "12/12/2017 09:45",
        "value": 1
    },
    {
        "date": "12/12/2017 09:50",
        "value": 1
    },
    {
        "date": "12/12/2017 09:55",
        "value": 1
    },
    {
        "date": "12/12/2017 10:00",
        "value": 1
    },
    {
        "date": "12/12/2017 10:05",
        "value": 1
    },
    {
        "date": "12/12/2017 10:10",
        "value": 1
    },
    {
        "date": "12/12/2017 10:15",
        "value": 1
    },
    {
        "date": "12/12/2017 10:20",
        "value": 1
    },
    {
        "date": "12/12/2017 10:25",
        "value": 1
    },
    {
        "date": "12/12/2017 10:30",
        "value": 1
    },
    {
        "date": "12/12/2017 10:35",
        "value": 1
    },
    {
        "date": "12/12/2017 10:40",
        "value": 1
    },
    {
        "date": "12/12/2017 10:45",
        "value": 1
    },
    {
        "date": "12/12/2017 10:50",
        "value": 1
    },
    {
        "date": "12/12/2017 10:55",
        "value": 1
    },
    {
        "date": "12/12/2017 11:00",
        "value": 1
    },
    {
        "date": "12/12/2017 11:05",
        "value": 1
    },
    {
        "date": "12/12/2017 11:10",
        "value": 1
    },
    {
        "date": "12/12/2017 11:15",
        "value": 1
    },
    {
        "date": "12/12/2017 11:20",
        "value": 1
    },
    {
        "date": "12/12/2017 11:25",
        "value": 1
    },
    {
        "date": "12/12/2017 11:30",
        "value": 1
    },
    {
        "date": "12/12/2017 11:35",
        "value": 1
    },
    {
        "date": "12/12/2017 11:40",
        "value": 1
    },
    {
        "date": "12/12/2017 11:45",
        "value": 1
    },
    {
        "date": "12/12/2017 11:50",
        "value": 1
    },
    {
        "date": "12/12/2017 11:55",
        "value": 1
    },
    {
        "date": "12/12/2017 12:00",
        "value": 1
    },
    {
        "date": "12/12/2017 12:05",
        "value": 1
    },
    {
        "date": "12/12/2017 12:10",
        "value": 1
    },
    {
        "date": "12/12/2017 12:15",
        "value": 1
    },
    {
        "date": "12/12/2017 12:20",
        "value": 1
    },
    {
        "date": "12/12/2017 12:25",
        "value": 1
    },
    {
        "date": "12/12/2017 12:30",
        "value": 1
    },
    {
        "date": "12/12/2017 12:35",
        "value": 1
    },
    {
        "date": "12/12/2017 12:40",
        "value": 1
    },
    {
        "date": "12/12/2017 12:45",
        "value": 1
    },
    {
        "date": "12/12/2017 12:50",
        "value": 1
    },
    {
        "date": "12/12/2017 12:55",
        "value": 1
    },
    {
        "date": "12/12/2017 13:00",
        "value": 1
    },
    {
        "date": "12/12/2017 13:05",
        "value": 1
    },
    {
        "date": "12/12/2017 13:10",
        "value": 1
    },
    {
        "date": "12/12/2017 13:15",
        "value": 1
    },
    {
        "date": "12/12/2017 13:20",
        "value": 1
    },
    {
        "date": "12/12/2017 13:25",
        "value": 1
    },
    {
        "date": "12/12/2017 13:30",
        "value": 1
    },
    {
        "date": "12/12/2017 13:35",
        "value": 1
    },
    {
        "date": "12/12/2017 13:40",
        "value": 1
    },
    {
        "date": "12/12/2017 13:45",
        "value": 1
    },
    {
        "date": "12/12/2017 13:50",
        "value": 1
    },
    {
        "date": "12/12/2017 13:55",
        "value": 1
    },
    {
        "date": "12/12/2017 14:00",
        "value": 1
    },
    {
        "date": "12/12/2017 14:05",
        "value": 1
    },
    {
        "date": "12/12/2017 14:10",
        "value": 1
    },
    {
        "date": "12/12/2017 14:15",
        "value": 1
    },
    {
        "date": "12/12/2017 14:20",
        "value": 1
    },
    {
        "date": "12/12/2017 14:25",
        "value": 1
    },
    {
        "date": "12/12/2017 14:30",
        "value": 1
    },
    {
        "date": "12/12/2017 14:35",
        "value": 1
    },
    {
        "date": "12/12/2017 14:40",
        "value": 1
    },
    {
        "date": "12/12/2017 14:45",
        "value": 1
    },
    {
        "date": "12/12/2017 14:50",
        "value": 1
    },
    {
        "date": "12/12/2017 14:55",
        "value": 1
    },
    {
        "date": "12/12/2017 15:00",
        "value": 1
    },
    {
        "date": "12/12/2017 15:05",
        "value": 1
    },
    {
        "date": "12/12/2017 15:10",
        "value": 1
    }
]

/*
const datas = [{
    "date": "03/30/2017 01:00",
    "value": 3.5
}, {
    "date": "03/30/2017 02:00",
    "value": 4
}, {
    "date": "03/30/2017 03:00"
}, {
    "date": "03/30/2017 04:00",
    "value": 2
}, {
    "date": "03/30/2017 05:00",
    "value": 2
}];
*/
const data = [{
    "date": "03/29/2017 10:00",
    "values": [2, 1, 3]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [3, 3, 1]
}, {
    "date": "03/29/2017 13:00",
    "values": [4, 5, 3]
}, {
    "date": "03/29/2017 14:00",
    "values": [5, 3, 2]
}, {
    "date": "03/29/2017 15:00",
    "values": [3, 2, 1]
}, {
    "date": "03/29/2017 16:00",
    "values": [3, 1, 3]
}];
/*
const data3 = [
    {
        "date": "12/06/2017 11:00",
        "value": 1
    },
    {
        "date": "12/06/2017 12:00",
        "value": 1
    },
    {
        "date": "12/06/2017 13:00",
        "value": 1
    },
    {
        "date": "12/06/2017 14:00",
        "value": 1
    },
    {
        "date": "12/06/2017 15:00",
        "value": 1
    },
    {
        "date": "12/06/2017 16:00",
        "value": 1
    },
    {
        "date": "12/06/2017 17:00",
        "value": 1
    },
    {
        "date": "12/06/2017 18:00",
        "value": 1
    },
    {
        "date": "12/06/2017 19:00",
        "value": 1
    },
    {
        "date": "12/06/2017 20:00",
        "value": 1
    },
    {
        "date": "12/06/2017 21:00",
        "value": 1
    },
    {
        "date": "12/06/2017 22:00",
        "value": 1
    },
    {
        "date": "12/06/2017 23:00",
        "value": 1
    },
    {
        "date": "12/07/2017 00:00",
        "value": 1
    },
    {
        "date": "12/07/2017 01:00",
        "value": 1
    },
    {
        "date": "12/07/2017 02:00",
        "value": 1
    },
    {
        "date": "12/07/2017 03:00",
        "value": 1
    },
    {
        "date": "12/07/2017 04:00",
        "value": 1
    },
    {
        "date": "12/07/2017 05:00",
        "value": 1
    },
    {
        "date": "12/07/2017 06:00",
        "value": 1
    },
    {
        "date": "12/07/2017 07:00",
        "value": 1
    },
    {
        "date": "12/07/2017 08:00",
        "value": 1
    },
    {
        "date": "12/07/2017 09:00",
        "value": 1
    },
    {
        "date": "12/07/2017 10:00",
        "value": 1
    },
    {
        "date": "12/07/2017 11:00",
        "value": 1
    },
    {
        "date": "12/07/2017 12:00",
        "value": 1
    },
    {
        "date": "12/07/2017 13:00",
        "value": 1
    },
    {
        "date": "12/07/2017 14:00",
        "value": 1
    },
    {
        "date": "12/07/2017 15:00",
        "value": 1
    },
    {
        "date": "12/07/2017 16:00",
        "value": 1
    },
    {
        "date": "12/07/2017 17:00",
        "value": 1
    },
    {
        "date": "12/07/2017 18:00",
        "value": 1
    },
    {
        "date": "12/07/2017 19:00",
        "value": 1
    },
    {
        "date": "12/07/2017 20:00",
        "value": 1
    },
    {
        "date": "12/07/2017 21:00",
        "value": 1
    },
    {
        "date": "12/07/2017 22:00",
        "value": 1
    },
    {
        "date": "12/07/2017 23:00",
        "value": 1
    },
    {
        "date": "12/08/2017 00:00",
        "value": 1
    },
    {
        "date": "12/08/2017 01:00",
        "value": 1
    },
    {
        "date": "12/08/2017 02:00",
        "value": 1
    },
    {
        "date": "12/08/2017 03:00",
        "value": 1
    },
    {
        "date": "12/08/2017 04:00",
        "value": 1
    },
    {
        "date": "12/08/2017 05:00",
        "value": 1
    },
    {
        "date": "12/08/2017 06:00",
        "value": 1
    },
    {
        "date": "12/08/2017 07:00",
        "value": 1
    },
    {
        "date": "12/08/2017 08:00",
        "value": 1
    },
    {
        "date": "12/08/2017 09:00",
        "value": 1
    },
    {
        "date": "12/08/2017 10:00",
        "value": 1
    },
    {
        "date": "12/08/2017 11:00",
        "value": 1
    },
    {
        "date": "12/08/2017 12:00",
        "value": 1
    },
    {
        "date": "12/08/2017 13:00",
        "value": 1
    },
    {
        "date": "12/08/2017 14:00",
        "value": 1
    },
    {
        "date": "12/08/2017 15:00",
        "value": 1
    },
    {
        "date": "12/08/2017 16:00",
        "value": 1
    },
    {
        "date": "12/08/2017 17:00",
        "value": 1
    },
    {
        "date": "12/08/2017 18:00",
        "value": 1
    },
    {
        "date": "12/08/2017 19:00",
        "value": 1
    },
    {
        "date": "12/08/2017 20:00",
        "value": 1
    },
    {
        "date": "12/08/2017 21:00",
        "value": 1
    },
    {
        "date": "12/08/2017 22:00",
        "value": 1
    },
    {
        "date": "12/08/2017 23:00",
        "value": 1
    },
    {
        "date": "12/09/2017 00:00",
        "value": 1
    },
    {
        "date": "12/09/2017 01:00",
        "value": 1
    },
    {
        "date": "12/09/2017 02:00",
        "value": 1
    },
    {
        "date": "12/09/2017 03:00",
        "value": 1
    },
    {
        "date": "12/09/2017 04:00",
        "value": 1
    },
    {
        "date": "12/09/2017 05:00",
        "value": 1
    },
    {
        "date": "12/09/2017 06:00",
        "value": 1
    },
    {
        "date": "12/09/2017 07:00",
        "value": 1
    },
    {
        "date": "12/09/2017 08:00",
        "value": 1
    },
    {
        "date": "12/09/2017 09:00",
        "value": 1
    },
    {
        "date": "12/09/2017 10:00",
        "value": 1
    },
    {
        "date": "12/09/2017 11:00",
        "value": 1
    },
    {
        "date": "12/09/2017 12:00",
        "value": 1
    },
    {
        "date": "12/09/2017 13:00",
        "value": 1
    },
    {
        "date": "12/09/2017 14:00",
        "value": 1
    },
    {
        "date": "12/09/2017 15:00",
        "value": 1
    },
    {
        "date": "12/09/2017 16:00",
        "value": 1
    },
    {
        "date": "12/09/2017 17:00",
        "value": 1
    },
    {
        "date": "12/09/2017 18:00",
        "value": 1
    },
    {
        "date": "12/09/2017 19:00",
        "value": 1
    },
    {
        "date": "12/09/2017 20:00",
        "value": 1
    },
    {
        "date": "12/09/2017 21:00",
        "value": 1
    },
    {
        "date": "12/09/2017 22:00",
        "value": 1
    },
    {
        "date": "12/09/2017 23:00",
        "value": 1
    },
    {
        "date": "12/10/2017 00:00",
        "value": 1
    },
    {
        "date": "12/10/2017 01:00",
        "value": 1
    },
    {
        "date": "12/10/2017 02:00",
        "value": 1
    },
    {
        "date": "12/10/2017 03:00",
        "value": 1
    },
    {
        "date": "12/10/2017 04:00",
        "value": 1
    },
    {
        "date": "12/10/2017 05:00",
        "value": 1
    },
    {
        "date": "12/10/2017 06:00",
        "value": 1
    },
    {
        "date": "12/10/2017 07:00",
        "value": 1
    },
    {
        "date": "12/10/2017 08:00",
        "value": 1
    },
    {
        "date": "12/10/2017 09:00",
        "value": 1
    },
    {
        "date": "12/10/2017 10:00",
        "value": 1
    },
    {
        "date": "12/10/2017 11:00",
        "value": 1
    },
    {
        "date": "12/10/2017 12:00",
        "value": 1
    },
    {
        "date": "12/10/2017 13:00",
        "value": 1
    },
    {
        "date": "12/10/2017 14:00",
        "value": 1
    },
    {
        "date": "12/10/2017 15:00",
        "value": 1
    },
    {
        "date": "12/10/2017 16:00",
        "value": 1
    },
    {
        "date": "12/10/2017 17:00",
        "value": 1
    },
    {
        "date": "12/10/2017 18:00",
        "value": 1
    },
    {
        "date": "12/10/2017 19:00",
        "value": 1
    },
    {
        "date": "12/10/2017 20:00",
        "value": 1
    },
    {
        "date": "12/10/2017 21:00",
        "value": 1
    },
    {
        "date": "12/10/2017 22:00",
        "value": 1
    },
    {
        "date": "12/10/2017 23:00",
        "value": 1
    },
    {
        "date": "12/11/2017 00:00",
        "value": 1
    },
    {
        "date": "12/11/2017 01:00",
        "value": 1
    },
    {
        "date": "12/11/2017 02:00",
        "value": 1
    },
    {
        "date": "12/11/2017 03:00",
        "value": 1
    },
    {
        "date": "12/11/2017 04:00",
        "value": 1
    },
    {
        "date": "12/11/2017 05:00",
        "value": 1
    },
    {
        "date": "12/11/2017 06:00",
        "value": 1
    },
    {
        "date": "12/11/2017 07:00",
        "value": 1
    },
    {
        "date": "12/11/2017 08:00",
        "value": 1
    },
    {
        "date": "12/11/2017 09:00",
        "value": 1
    },
    {
        "date": "12/11/2017 10:00",
        "value": 1
    },
    {
        "date": "12/11/2017 11:00",
        "value": 1
    },
    {
        "date": "12/11/2017 12:00",
        "value": 1
    },
    {
        "date": "12/11/2017 13:00",
        "value": 1
    },
    {
        "date": "12/11/2017 14:00",
        "value": 1
    },
    {
        "date": "12/11/2017 15:00",
        "value": 1
    },
    {
        "date": "12/11/2017 16:00",
        "value": 1
    },
    {
        "date": "12/11/2017 17:00",
        "value": 1
    },
    {
        "date": "12/11/2017 18:00",
        "value": 1
    },
    {
        "date": "12/11/2017 19:00",
        "value": 1
    },
    {
        "date": "12/11/2017 20:00",
        "value": 1
    },
    {
        "date": "12/11/2017 21:00",
        "value": 1
    },
    {
        "date": "12/11/2017 22:00",
        "value": 1
    },
    {
        "date": "12/11/2017 23:00",
        "value": 1
    },
    {
        "date": "12/12/2017 00:00",
        "value": 1
    },
    {
        "date": "12/12/2017 01:00",
        "value": 1
    },
    {
        "date": "12/12/2017 02:00",
        "value": 1
    },
    {
        "date": "12/12/2017 03:00",
        "value": 1
    },
    {
        "date": "12/12/2017 04:00",
        "value": 1
    },
    {
        "date": "12/12/2017 05:00",
        "value": 1
    },
    {
        "date": "12/12/2017 06:00",
        "value": 1
    },
    {
        "date": "12/12/2017 07:00",
        "value": 1
    },
    {
        "date": "12/12/2017 08:00",
        "value": 1
    },
    {
        "date": "12/12/2017 09:00",
        "value": 1
    },
    {
        "date": "12/12/2017 10:00",
        "value": 1
    },
    {
        "date": "12/12/2017 11:00",
        "value": 1
    },
    {
        "date": "12/12/2017 12:00",
        "value": 1
    },
    {
        "date": "12/12/2017 13:00",
        "value": 1
    },
    {
        "date": "12/12/2017 14:00",
        "value": 1
    },
    {
        "date": "12/12/2017 15:00",
        "value": 1
    },
    {
        "date": "12/12/2017 16:00",
        "value": 1
    },
    {
        "date": "12/12/2017 17:00",
        "value": 1
    },
    {
        "date": "12/12/2017 18:00",
        "value": 1
    },
    {
        "date": "12/12/2017 19:00",
        "value": 1
    },
    {
        "date": "12/12/2017 20:00",
        "value": 1
    },
    {
        "date": "12/12/2017 21:00",
        "value": 1
    },
    {
        "date": "12/12/2017 22:00",
        "value": 1
    },
    {
        "date": "12/12/2017 23:00",
        "value": 1
    },
    {
        "date": "12/13/2017 00:00",
        "value": 1
    },
    {
        "date": "12/13/2017 01:00",
        "value": 1
    },
    {
        "date": "12/13/2017 02:00",
        "value": 1
    },
    {
        "date": "12/13/2017 03:00",
        "value": 1
    },
    {
        "date": "12/13/2017 04:00",
        "value": 1
    },
    {
        "date": "12/13/2017 05:00",
        "value": 1
    },
    {
        "date": "12/13/2017 06:00",
        "value": 1
    },
    {
        "date": "12/13/2017 07:00",
        "value": 1
    },
    {
        "date": "12/13/2017 08:00",
        "value": 1
    },
    {
        "date": "12/13/2017 09:00",
        "value": 1
    },
    {
        "date": "12/13/2017 10:00",
        "value": 1
    },
    {
        "date": "12/13/2017 11:00",
        "value": 1
    }
]
*/
/*
const data2 = [{
    "date": "03/29/2017 10:00",
    "values": [2, 1, 3]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [3, 3, 1]
}, {
    "date": "03/29/2017 13:00",
    "values": [4, 5, 3]
}];
*/
const names = ["Label 1", "Label 2", "Label 3"]

//const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];


class TimelineSample extends React.Component {
    constructor() {
        super();
        this._onTimeRangeChange = this._onTimeRangeChange.bind(this);
        this._onPrev = this._onPrev.bind(this);
        this._onPause = this._onPause.bind(this);
        this._onNext = this._onNext.bind(this);
        this._onLast = this._onLast.bind(this);
        this.state = ({ data: data2 })
    }
    _onTimeRangeChange(event) {
        console.log(event);
    }
    _onPrev(event) {
        console.log(event);
    }
    _onPause(event) {
        console.log(event);
    }
    _onNext(event) {
        console.log(event);
    }
    _onLast(event) {
        console.log(event);
    }
    render() {
        return (
            <div><br /><br />
                <dnx-ttt-ttt data={'data2'} test={'test2'}></dnx-ttt-ttt>
                <LineEverywhere
                    data={data1}
                    collapsed={false}
                    sliders={false}
                    minPeriod={"5mm"}
                    exprt={false}
                ></LineEverywhere><br /><br />
                <LineEverywhere
                    data={data1}
                    collapsed={false}
                    sliders={false}
                    minPeriod={"5mm"}
                    exprt={false}
                ></LineEverywhere><br /><br />
                <div>Timeline Slider Option 1</div>
                <LineEverywhere
                    data={this.state.data}
                    collapsed={false}
                    sliders={true}
                    onTimeRangeChange={this._onTimeRangeChange}
                    onPrev={this._onPrev}
                    onPause={this._onPause}
                    onNext={this._onNext}
                    onLast={this._onLast}
                    minperiod={"5mm"}
                    linevisibility={false}
                    period={'24h'}
                    exprt={false}
                ></LineEverywhere><br /><br />
                <BarEverywhere
                    data={data}
                    names={names}
                    topValue={[4, 5, 4, 5]}
                    bottomValue={[1, 2, 1, 2]}
                    topname={'XXXXXXXXXXX'}
                    bottomname={'XXXXXXXXXXX'}
                    rotate={false}
                    stack={'regular'}
                    xformat={'date'}
                    xtitle={'Time'}
                    ytitle={'Title for Y'}
                    exprt={false}
                ></BarEverywhere>
            </div>
        );
    }
}

export default TimelineSample;

export const textCode = `
import React from 'react';
import { DnxTimelineS, DnxBar } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data1 = [{
    "date": "03/29/2017 10:00",
    "value": 2
}, {
    "date": "03/29/2017 10:05",
    "value": 2.5
}, {
    "date": "03/29/2017 10:10",
    "value": 3
}, {
    "date": "03/29/2017 10:15",
    "value": 3.5
}, {
    "date": "03/29/2017 10:20",
    "value": 4
}, {
    "date": "03/29/2017 10:25",
    "value": 4.5
}, {
    "date": "03/29/2017 10:30",
    "value": 5
}, {
    "date": "03/29/2017 10:35",
    "value": 4.5
}, {
    "date": "03/29/2017 10:40",
    "value": 4
}, {
    "date": "03/29/2017 10:45",
    "value": 3.5
}, {
    "date": "03/29/2017 10:50",
    "value": 3
}, {
    "date": "03/29/2017 10:55",
    "value": 2.5
}, {
    "date": "03/29/2017 11:00",
    "value": 2
}, {
    "date": "03/29/2017 11:05",
    "value": 1.5
}, {
    "date": "03/29/2017 11:10",
    "value": 1
}, {
    "date": "03/29/2017 11:15",
    "value": 8
}, {
    "date": "03/29/2017 11:20",
    "value": 2
}, {
    "date": "03/29/2017 11:25",
    "value": 9
}, {
    "date": "03/29/2017 11:30",
    "value": 4.5
}, {
    "date": "03/29/2017 11:35",
    "value": 10
}, {
    "date": "03/29/2017 11:40",
    "value": 10
}, {
    "date": "03/29/2017 11:45",
    "value": 10
}, {
    "date": "03/29/2017 11:50",
    "value": 1
}, {
    "date": "03/29/2017 11:55",
    "value": 1
}, {
    "date": "03/29/2017 12:00",
    "value": 1
}, {
    "date": "03/29/2017 12:05",
    "value": 3.5
}, {
    "date": "03/29/2017 12:10",
    "value": 3
}, {
    "date": "03/29/2017 12:15",
    "value": 2.5
}, {
    "date": "03/29/2017 12:20",
    "value": 2
}, {
    "date": "03/29/2017 12:25",
    "value": 1.5
}, {
    "date": "03/29/2017 12:30",
    "value": 1
}, {
    "date": "03/29/2017 12:35",
    "value": 1.5
}, {
    "date": "03/29/2017 12:40",
    "value": 2
}, {
    "date": "03/29/2017 12:45",
    "value": 2.5
}, {
    "date": "03/29/2017 12:50",
    "value": 3
}, {
    "date": "03/29/2017 12:55",
    "value": 3.5
}, {
    "date": "03/29/2017 13:00",
    "value": 2
}, {
    "date": "03/29/2017 13:05",
    "value": 2
}, {
    "date": "03/29/2017 13:10",
    "value": 5
}, {
    "date": "03/29/2017 13:15",
    "value": 4
}, {
    "date": "03/29/2017 13:20",
    "value": 3
}, {
    "date": "03/29/2017 13:25",
    "value": 2
}, {
    "date": "03/29/2017 13:30",
    "value": 2
}, {
    "date": "03/29/2017 13:35",
    "value": 3
}, {
    "date": "03/29/2017 13:40",
    "value": 2
}, {
    "date": "03/29/2017 13:45",
    "value": 5
}, {
    "date": "03/29/2017 13:50",
    "value": 4
}, {
    "date": "03/29/2017 13:55",
    "value": 4
}, {
    "date": "03/29/2017 14:00",
    "value": 2
}, {
    "date": "03/29/2017 14:05",
    "value": 2
}, {
    "date": "03/29/2017 14:10",
    "value": 5
}, {
    "date": "03/29/2017 14:15",
    "value": 4
}, { //Something needs to be passed (at least date), then equalSpacing works. If not pass here, create object in WC side.
    "date": "03/29/2017 14:20"//,
    //"value": 3
}, {
    "date": "03/29/2017 14:25"// ,
    //"value": 2
}, {
    "date": "03/29/2017 14:30"//,
    //"value": 2
}, {
    "date": "03/29/2017 14:35"//,
    //"value": 3
}, {
    "date": "03/29/2017 14:40",
    "value": 2
}, {
    "date": "03/29/2017 14:45",
    "value": 5
}, {
    "date": "03/29/2017 14:50",
    "value": 4
}, {
    "date": "03/29/2017 14:55",
    "value": 2
}];

/*
const dataLine = [{
    "date": "03/29/2017 10:00",
    "value": 3.5
}, {
    "date": "03/29/2017 11:00",
    "value": 4
}, {
    "date": "03/29/2017 12:00",
    "value": 3
}, {
    "date": "03/29/2017 13:00",
    "value": 2
}, {
    "date": "03/29/2017 14:00",
    "value": 1,
    "event": true
}, {
    "date": "03/29/2017 15:00",
    "value": 3
},/*  Non collapsed needs date entry to show the gap. Collapsed needs this to be removed or change the object to another number when there is a gap.
{
    "date": "03/29/2017 16:00"
}, {
    "date": "03/29/2017 17:00",
    "value": 3.5
}, {
    "date": "03/29/2017 18:00",
    "value": 9
}, {
    "date": "03/29/2017 19:00",
    "value": 4
}, {
    "date": "03/29/2017 20:00",
    "value": 5
}, {
    "date": "03/29/2017 21:00",
    "value": 7
}, {
    "date": "03/29/2017 22:00",
    "value": 8
}, {
    "date": "03/29/2017 23:00",
    "value": 9.5
}, {
    "date": "03/29/2017 24:00",
    "value": 8
}, {
    "date": "03/30/2017 01:00",
    "value": 7
}, {
    "date": "03/30/2017 02:00",
    "value": 6
}, {
    "date": "03/30/2017 03:00",
    "value": 9
}, {
    "date": "03/30/2017 04:00",
    "value": 10
}, {
    "date": "03/30/2017 05:00",
    "value": 9
}, {
    "date": "03/30/2017 06:00",
    "value": 9
}];
*/
const data2 = [
    {
        "date": "12/11/2017 15:10",
        "value": 1
    },
    {
        "date": "12/11/2017 15:15",
        "value": 1
    },
    {
        "date": "12/11/2017 15:20",
        "value": 1
    },
    {
        "date": "12/11/2017 15:25",
        "value": 1
    },
    {
        "date": "12/11/2017 15:30",
        "value": 1
    },
    {
        "date": "12/11/2017 15:35",
        "value": 1
    },
    {
        "date": "12/11/2017 15:40",
        "value": 1
    },
    {
        "date": "12/11/2017 15:45",
        "value": 1
    },
    {
        "date": "12/11/2017 15:50",
        "value": 1
    },
    {
        "date": "12/11/2017 15:55",
        "value": 1
    },
    {
        "date": "12/11/2017 16:00",
        "value": 1
    },
    {
        "date": "12/11/2017 16:05",
        "value": 1
    },
    {
        "date": "12/11/2017 16:10",
        "value": 1
    },
    {
        "date": "12/11/2017 16:15",
        "value": 1
    },
    {
        "date": "12/11/2017 16:20",
        "value": 1
    },
    {
        "date": "12/11/2017 16:25",
        "value": 1
    },
    {
        "date": "12/11/2017 16:30",
        "value": 1
    },
    {
        "date": "12/11/2017 16:35",
        "value": 1
    },
    {
        "date": "12/11/2017 16:40",
        "value": 1
    },
    {
        "date": "12/11/2017 16:45",
        "value": 1
    },
    {
        "date": "12/11/2017 16:50",
        "value": 1
    },
    {
        "date": "12/11/2017 16:55",
        "value": 1
    },
    {
        "date": "12/11/2017 17:00",
        "value": 1
    },
    {
        "date": "12/11/2017 17:05",
        "value": 1
    },
    {
        "date": "12/11/2017 17:10",
        "value": 1
    },
    {
        "date": "12/11/2017 17:15",
        "value": 1
    },
    {
        "date": "12/11/2017 17:20",
        "value": 1
    },
    {
        "date": "12/11/2017 17:25",
        "value": 1
    },
    {
        "date": "12/11/2017 17:30",
        "value": 1
    },
    {
        "date": "12/11/2017 17:35",
        "value": 1
    },
    {
        "date": "12/11/2017 17:40",
        "value": 1
    },
    {
        "date": "12/11/2017 17:45",
        "value": 1
    },
    {
        "date": "12/11/2017 17:50",
        "value": 1
    },
    {
        "date": "12/11/2017 17:55",
        "value": 1
    },
    {
        "date": "12/11/2017 18:00",
        "value": 1
    },
    {
        "date": "12/11/2017 18:05",
        "value": 1
    },
    {
        "date": "12/11/2017 18:10",
        "value": 1
    },
    {
        "date": "12/11/2017 18:15",
        "value": 1
    },
    {
        "date": "12/11/2017 18:20",
        "value": 1
    },
    {
        "date": "12/11/2017 18:25",
        "value": 1
    },
    {
        "date": "12/11/2017 18:30",
        "value": 1
    },
    {
        "date": "12/11/2017 18:35",
        "value": 1
    },
    {
        "date": "12/11/2017 18:40",
        "value": 1
    },
    {
        "date": "12/11/2017 18:45",
        "value": 1
    },
    {
        "date": "12/11/2017 18:50",
        "value": 1
    },
    {
        "date": "12/11/2017 18:55",
        "value": 1
    },
    {
        "date": "12/11/2017 19:00",
        "value": 1
    },
    {
        "date": "12/11/2017 19:05",
        "value": 1
    },
    {
        "date": "12/11/2017 19:10",
        "value": 1
    },
    {
        "date": "12/11/2017 19:15",
        "value": 1
    },
    {
        "date": "12/11/2017 19:20",
        "value": 1
    },
    {
        "date": "12/11/2017 19:25",
        "value": 1
    },
    {
        "date": "12/11/2017 19:30",
        "value": 1
    },
    {
        "date": "12/11/2017 19:35",
        "value": 1
    },
    {
        "date": "12/11/2017 19:40",
        "value": 1
    },
    {
        "date": "12/11/2017 19:45",
        "value": 1
    },
    {
        "date": "12/11/2017 19:50",
        "value": 1
    },
    {
        "date": "12/11/2017 19:55",
        "value": 1
    },
    {
        "date": "12/11/2017 20:00",
        "value": 1
    },
    {
        "date": "12/11/2017 20:05",
        "value": 1
    },
    {
        "date": "12/11/2017 20:10",
        "value": 1
    },
    {
        "date": "12/11/2017 20:15",
        "value": 1
    },
    {
        "date": "12/11/2017 20:20",
        "value": 1
    },
    {
        "date": "12/11/2017 20:25",
        "value": 1
    },
    {
        "date": "12/11/2017 20:30",
        "value": 1
    },
    {
        "date": "12/11/2017 20:35",
        "value": 1
    },
    {
        "date": "12/11/2017 20:40",
        "value": 1
    },
    {
        "date": "12/11/2017 20:45",
        "value": 1
    },
    {
        "date": "12/11/2017 20:50",
        "value": 1
    },
    {
        "date": "12/11/2017 20:55",
        "value": 1
    },
    {
        "date": "12/11/2017 21:00",
        "value": 1
    },
    {
        "date": "12/11/2017 21:05",
        "value": 1
    },
    {
        "date": "12/11/2017 21:10",
        "value": 1
    },
    {
        "date": "12/11/2017 21:15",
        "value": 1
    },
    {
        "date": "12/11/2017 21:20",
        "value": 1
    },
    {
        "date": "12/11/2017 21:25",
        "value": 1
    },
    {
        "date": "12/11/2017 21:30",
        "value": 1
    },
    {
        "date": "12/11/2017 21:35",
        "value": 1
    },
    {
        "date": "12/11/2017 21:40",
        "value": 1
    },
    {
        "date": "12/11/2017 21:45",
        "value": 1
    },
    {
        "date": "12/11/2017 21:50",
        "value": 1
    },
    {
        "date": "12/11/2017 21:55",
        "value": 1
    },
    {
        "date": "12/11/2017 22:00",
        "value": 1
    },
    {
        "date": "12/11/2017 22:05",
        "value": 1
    },
    {
        "date": "12/11/2017 22:10",
        "value": 1
    },
    {
        "date": "12/11/2017 22:15",
        "value": 1
    },
    {
        "date": "12/11/2017 22:20",
        "value": 1
    },
    {
        "date": "12/11/2017 22:25",
        "value": 1
    },
    {
        "date": "12/11/2017 22:30",
        "value": 1
    },
    {
        "date": "12/11/2017 22:35",
        "value": 1
    },
    {
        "date": "12/11/2017 22:40",
        "value": 1
    },
    {
        "date": "12/11/2017 22:45",
        "value": 1
    },
    {
        "date": "12/11/2017 22:50",
        "value": 1
    },
    {
        "date": "12/11/2017 22:55",
        "value": 1
    },
    {
        "date": "12/11/2017 23:00",
        "value": 1
    },
    {
        "date": "12/11/2017 23:05",
        "value": 1
    },
    {
        "date": "12/11/2017 23:10",
        "value": 1
    },
    {
        "date": "12/11/2017 23:15",
        "value": 1
    },
    {
        "date": "12/11/2017 23:20",
        "value": 1
    },
    {
        "date": "12/11/2017 23:25",
        "value": 1
    },
    {
        "date": "12/11/2017 23:30",
        "value": 1
    },
    {
        "date": "12/11/2017 23:35",
        "value": 1
    },
    {
        "date": "12/11/2017 23:40",
        "value": 1
    },
    {
        "date": "12/11/2017 23:45",
        "value": 1
    },
    {
        "date": "12/11/2017 23:50",
        "value": 1
    },
    {
        "date": "12/11/2017 23:55",
        "value": 1
    },
    {
        "date": "12/12/2017 00:00",
        "value": 1
    },
    {
        "date": "12/12/2017 00:05",
        "value": 1
    },
    {
        "date": "12/12/2017 00:10",
        "value": 1
    },
    {
        "date": "12/12/2017 00:15",
        "value": 1
    },
    {
        "date": "12/12/2017 00:20",
        "value": 1
    },
    {
        "date": "12/12/2017 00:25",
        "value": 1
    },
    {
        "date": "12/12/2017 00:30",
        "value": 1
    },
    {
        "date": "12/12/2017 00:35",
        "value": 1
    },
    {
        "date": "12/12/2017 00:40",
        "value": 1
    },
    {
        "date": "12/12/2017 00:45",
        "value": 1
    },
    {
        "date": "12/12/2017 00:50",
        "value": 1
    },
    {
        "date": "12/12/2017 00:55",
        "value": 1
    },
    {
        "date": "12/12/2017 01:00",
        "value": 1
    },
    {
        "date": "12/12/2017 01:05",
        "value": 1
    },
    {
        "date": "12/12/2017 01:10",
        "value": 1
    },
    {
        "date": "12/12/2017 01:15",
        "value": 1
    },
    {
        "date": "12/12/2017 01:20",
        "value": 1
    },
    {
        "date": "12/12/2017 01:25",
        "value": 1
    },
    {
        "date": "12/12/2017 01:30",
        "value": 1
    },
    {
        "date": "12/12/2017 01:35",
        "value": 1
    },
    {
        "date": "12/12/2017 01:40",
        "value": 1
    },
    {
        "date": "12/12/2017 01:45",
        "value": 1
    },
    {
        "date": "12/12/2017 01:50",
        "value": 1
    },
    {
        "date": "12/12/2017 01:55",
        "value": 1
    },
    {
        "date": "12/12/2017 02:00",
        "value": 1
    },
    {
        "date": "12/12/2017 02:05",
        "value": 1
    },
    {
        "date": "12/12/2017 02:10",
        "value": 1
    },
    {
        "date": "12/12/2017 02:15",
        "value": 1
    },
    {
        "date": "12/12/2017 02:20",
        "value": 1
    },
    {
        "date": "12/12/2017 02:25",
        "value": 1
    },
    {
        "date": "12/12/2017 02:30",
        "value": 1
    },
    {
        "date": "12/12/2017 02:35",
        "value": 1
    },
    {
        "date": "12/12/2017 02:40",
        "value": 1
    },
    {
        "date": "12/12/2017 02:45",
        "value": 1
    },
    {
        "date": "12/12/2017 02:50",
        "value": 1
    },
    {
        "date": "12/12/2017 02:55",
        "value": 1
    },
    {
        "date": "12/12/2017 03:00",
        "value": 1
    },
    {
        "date": "12/12/2017 03:05",
        "value": 1
    },
    {
        "date": "12/12/2017 03:10",
        "value": 1
    },
    {
        "date": "12/12/2017 03:15",
        "value": 1
    },
    {
        "date": "12/12/2017 03:20",
        "value": 1
    },
    {
        "date": "12/12/2017 03:25",
        "value": 1
    },
    {
        "date": "12/12/2017 03:30",
        "value": 1
    },
    {
        "date": "12/12/2017 03:35",
        "value": 1
    },
    {
        "date": "12/12/2017 03:40",
        "value": 1
    },
    {
        "date": "12/12/2017 03:45",
        "value": 1
    },
    {
        "date": "12/12/2017 03:50",
        "value": 1
    },
    {
        "date": "12/12/2017 03:55",
        "value": 1
    },
    {
        "date": "12/12/2017 04:00",
        "value": 1
    },
    {
        "date": "12/12/2017 04:05",
        "value": 1
    },
    {
        "date": "12/12/2017 04:10",
        "value": 1
    },
    {
        "date": "12/12/2017 04:15",
        "value": 1
    },
    {
        "date": "12/12/2017 04:20",
        "value": 1
    },
    {
        "date": "12/12/2017 04:25",
        "value": 1
    },
    {
        "date": "12/12/2017 04:30",
        "value": 1
    },
    {
        "date": "12/12/2017 04:35",
        "value": 1
    },
    {
        "date": "12/12/2017 04:40",
        "value": 1
    },
    {
        "date": "12/12/2017 04:45",
        "value": 1
    },
    {
        "date": "12/12/2017 04:50",
        "value": 1
    },
    {
        "date": "12/12/2017 04:55",
        "value": 1
    },
    {
        "date": "12/12/2017 05:00",
        "value": 1
    },
    {
        "date": "12/12/2017 05:05",
        "value": 1
    },
    {
        "date": "12/12/2017 05:10",
        "value": 1
    },
    {
        "date": "12/12/2017 05:15",
        "value": 1
    },
    {
        "date": "12/12/2017 05:20",
        "value": 1
    },
    {
        "date": "12/12/2017 05:25",
        "value": 1
    },
    {
        "date": "12/12/2017 05:30",
        "value": 1
    },
    {
        "date": "12/12/2017 05:35",
        "value": 1
    },
    {
        "date": "12/12/2017 05:40",
        "value": 1
    },
    {
        "date": "12/12/2017 05:45",
        "value": 1
    },
    {
        "date": "12/12/2017 05:50",
        "value": 1
    },
    {
        "date": "12/12/2017 05:55",
        "value": 1
    },
    {
        "date": "12/12/2017 06:00",
        "value": 1
    },
    {
        "date": "12/12/2017 06:05",
        "value": 1
    },
    {
        "date": "12/12/2017 06:10",
        "value": 1
    },
    {
        "date": "12/12/2017 06:15",
        "value": 1
    },
    {
        "date": "12/12/2017 06:20",
        "value": 1
    },
    {
        "date": "12/12/2017 06:25",
        "value": 1
    },
    {
        "date": "12/12/2017 06:30",
        "value": 1
    },
    {
        "date": "12/12/2017 06:35",
        "value": 1
    },
    {
        "date": "12/12/2017 06:40",
        "value": 1
    },
    {
        "date": "12/12/2017 06:45",
        "value": 1
    },
    {
        "date": "12/12/2017 06:50",
        "value": 1
    },
    {
        "date": "12/12/2017 06:55",
        "value": 1
    },
    {
        "date": "12/12/2017 07:00",
        "value": 1
    },
    {
        "date": "12/12/2017 07:05",
        "value": 1
    },
    {
        "date": "12/12/2017 07:10",
        "value": 1
    },
    {
        "date": "12/12/2017 07:15",
        "value": 1
    },
    {
        "date": "12/12/2017 07:20",
        "value": 1
    },
    {
        "date": "12/12/2017 07:25",
        "value": 1
    },
    {
        "date": "12/12/2017 07:30",
        "value": 1
    },
    {
        "date": "12/12/2017 07:35",
        "value": 1
    },
    {
        "date": "12/12/2017 07:40",
        "value": 1
    },
    {
        "date": "12/12/2017 07:45",
        "value": 1
    },
    {
        "date": "12/12/2017 07:50",
        "value": 1
    },
    {
        "date": "12/12/2017 07:55",
        "value": 1
    },
    {
        "date": "12/12/2017 08:00",
        "value": 1
    },
    {
        "date": "12/12/2017 08:05",
        "value": 1
    },
    {
        "date": "12/12/2017 08:10",
        "value": 1
    },
    {
        "date": "12/12/2017 08:15",
        "value": 1
    },
    {
        "date": "12/12/2017 08:20",
        "value": 1
    },
    {
        "date": "12/12/2017 08:25",
        "value": 1
    },
    {
        "date": "12/12/2017 08:30",
        "value": 1
    },
    {
        "date": "12/12/2017 08:35",
        "value": 1
    },
    {
        "date": "12/12/2017 08:40",
        "value": 1
    },
    {
        "date": "12/12/2017 08:45",
        "value": 1
    },
    {
        "date": "12/12/2017 08:50",
        "value": 1
    },
    {
        "date": "12/12/2017 08:55",
        "value": 1
    },
    {
        "date": "12/12/2017 09:00",
        "value": 1
    },
    {
        "date": "12/12/2017 09:05",
        "value": 1
    },
    {
        "date": "12/12/2017 09:10",
        "value": 1
    },
    {
        "date": "12/12/2017 09:15",
        "value": 1
    },
    {
        "date": "12/12/2017 09:20",
        "value": 1
    },
    {
        "date": "12/12/2017 09:25",
        "value": 1
    },
    {
        "date": "12/12/2017 09:30",
        "value": 1
    },
    {
        "date": "12/12/2017 09:35",
        "value": 1
    },
    {
        "date": "12/12/2017 09:40",
        "value": 1
    },
    {
        "date": "12/12/2017 09:45",
        "value": 1
    },
    {
        "date": "12/12/2017 09:50",
        "value": 1
    },
    {
        "date": "12/12/2017 09:55",
        "value": 1
    },
    {
        "date": "12/12/2017 10:00",
        "value": 1
    },
    {
        "date": "12/12/2017 10:05",
        "value": 1
    },
    {
        "date": "12/12/2017 10:10",
        "value": 1
    },
    {
        "date": "12/12/2017 10:15",
        "value": 1
    },
    {
        "date": "12/12/2017 10:20",
        "value": 1
    },
    {
        "date": "12/12/2017 10:25",
        "value": 1
    },
    {
        "date": "12/12/2017 10:30",
        "value": 1
    },
    {
        "date": "12/12/2017 10:35",
        "value": 1
    },
    {
        "date": "12/12/2017 10:40",
        "value": 1
    },
    {
        "date": "12/12/2017 10:45",
        "value": 1
    },
    {
        "date": "12/12/2017 10:50",
        "value": 1
    },
    {
        "date": "12/12/2017 10:55",
        "value": 1
    },
    {
        "date": "12/12/2017 11:00",
        "value": 1
    },
    {
        "date": "12/12/2017 11:05",
        "value": 1
    },
    {
        "date": "12/12/2017 11:10",
        "value": 1
    },
    {
        "date": "12/12/2017 11:15",
        "value": 1
    },
    {
        "date": "12/12/2017 11:20",
        "value": 1
    },
    {
        "date": "12/12/2017 11:25",
        "value": 1
    },
    {
        "date": "12/12/2017 11:30",
        "value": 1
    },
    {
        "date": "12/12/2017 11:35",
        "value": 1
    },
    {
        "date": "12/12/2017 11:40",
        "value": 1
    },
    {
        "date": "12/12/2017 11:45",
        "value": 1
    },
    {
        "date": "12/12/2017 11:50",
        "value": 1
    },
    {
        "date": "12/12/2017 11:55",
        "value": 1
    },
    {
        "date": "12/12/2017 12:00",
        "value": 1
    },
    {
        "date": "12/12/2017 12:05",
        "value": 1
    },
    {
        "date": "12/12/2017 12:10",
        "value": 1
    },
    {
        "date": "12/12/2017 12:15",
        "value": 1
    },
    {
        "date": "12/12/2017 12:20",
        "value": 1
    },
    {
        "date": "12/12/2017 12:25",
        "value": 1
    },
    {
        "date": "12/12/2017 12:30",
        "value": 1
    },
    {
        "date": "12/12/2017 12:35",
        "value": 1
    },
    {
        "date": "12/12/2017 12:40",
        "value": 1
    },
    {
        "date": "12/12/2017 12:45",
        "value": 1
    },
    {
        "date": "12/12/2017 12:50",
        "value": 1
    },
    {
        "date": "12/12/2017 12:55",
        "value": 1
    },
    {
        "date": "12/12/2017 13:00",
        "value": 1
    },
    {
        "date": "12/12/2017 13:05",
        "value": 1
    },
    {
        "date": "12/12/2017 13:10",
        "value": 1
    },
    {
        "date": "12/12/2017 13:15",
        "value": 1
    },
    {
        "date": "12/12/2017 13:20",
        "value": 1
    },
    {
        "date": "12/12/2017 13:25",
        "value": 1
    },
    {
        "date": "12/12/2017 13:30",
        "value": 1
    },
    {
        "date": "12/12/2017 13:35",
        "value": 1
    },
    {
        "date": "12/12/2017 13:40",
        "value": 1
    },
    {
        "date": "12/12/2017 13:45",
        "value": 1
    },
    {
        "date": "12/12/2017 13:50",
        "value": 1
    },
    {
        "date": "12/12/2017 13:55",
        "value": 1
    },
    {
        "date": "12/12/2017 14:00",
        "value": 1
    },
    {
        "date": "12/12/2017 14:05",
        "value": 1
    },
    {
        "date": "12/12/2017 14:10",
        "value": 1
    },
    {
        "date": "12/12/2017 14:15",
        "value": 1
    },
    {
        "date": "12/12/2017 14:20",
        "value": 1
    },
    {
        "date": "12/12/2017 14:25",
        "value": 1
    },
    {
        "date": "12/12/2017 14:30",
        "value": 1
    },
    {
        "date": "12/12/2017 14:35",
        "value": 1
    },
    {
        "date": "12/12/2017 14:40",
        "value": 1
    },
    {
        "date": "12/12/2017 14:45",
        "value": 1
    },
    {
        "date": "12/12/2017 14:50",
        "value": 1
    },
    {
        "date": "12/12/2017 14:55",
        "value": 1
    },
    {
        "date": "12/12/2017 15:00",
        "value": 1
    },
    {
        "date": "12/12/2017 15:05",
        "value": 1
    },
    {
        "date": "12/12/2017 15:10",
        "value": 1
    }
]

/*
const datas = [{
    "date": "03/30/2017 01:00",
    "value": 3.5
}, {
    "date": "03/30/2017 02:00",
    "value": 4
}, {
    "date": "03/30/2017 03:00"
}, {
    "date": "03/30/2017 04:00",
    "value": 2
}, {
    "date": "03/30/2017 05:00",
    "value": 2
}];
*/
const data = [{
    "date": "03/29/2017 10:00",
    "values": [2, 1, 3]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [3, 3, 1]
}, {
    "date": "03/29/2017 13:00",
    "values": [4, 5, 3]
}, {
    "date": "03/29/2017 14:00",
    "values": [5, 3, 2]
}, {
    "date": "03/29/2017 15:00",
    "values": [3, 2, 1]
}, {
    "date": "03/29/2017 16:00",
    "values": [3, 1, 3]
}];
/*
const data3 = [
    {
        "date": "12/06/2017 11:00",
        "value": 1
    },
    {
        "date": "12/06/2017 12:00",
        "value": 1
    },
    {
        "date": "12/06/2017 13:00",
        "value": 1
    },
    {
        "date": "12/06/2017 14:00",
        "value": 1
    },
    {
        "date": "12/06/2017 15:00",
        "value": 1
    },
    {
        "date": "12/06/2017 16:00",
        "value": 1
    },
    {
        "date": "12/06/2017 17:00",
        "value": 1
    },
    {
        "date": "12/06/2017 18:00",
        "value": 1
    },
    {
        "date": "12/06/2017 19:00",
        "value": 1
    },
    {
        "date": "12/06/2017 20:00",
        "value": 1
    },
    {
        "date": "12/06/2017 21:00",
        "value": 1
    },
    {
        "date": "12/06/2017 22:00",
        "value": 1
    },
    {
        "date": "12/06/2017 23:00",
        "value": 1
    },
    {
        "date": "12/07/2017 00:00",
        "value": 1
    },
    {
        "date": "12/07/2017 01:00",
        "value": 1
    },
    {
        "date": "12/07/2017 02:00",
        "value": 1
    },
    {
        "date": "12/07/2017 03:00",
        "value": 1
    },
    {
        "date": "12/07/2017 04:00",
        "value": 1
    },
    {
        "date": "12/07/2017 05:00",
        "value": 1
    },
    {
        "date": "12/07/2017 06:00",
        "value": 1
    },
    {
        "date": "12/07/2017 07:00",
        "value": 1
    },
    {
        "date": "12/07/2017 08:00",
        "value": 1
    },
    {
        "date": "12/07/2017 09:00",
        "value": 1
    },
    {
        "date": "12/07/2017 10:00",
        "value": 1
    },
    {
        "date": "12/07/2017 11:00",
        "value": 1
    },
    {
        "date": "12/07/2017 12:00",
        "value": 1
    },
    {
        "date": "12/07/2017 13:00",
        "value": 1
    },
    {
        "date": "12/07/2017 14:00",
        "value": 1
    },
    {
        "date": "12/07/2017 15:00",
        "value": 1
    },
    {
        "date": "12/07/2017 16:00",
        "value": 1
    },
    {
        "date": "12/07/2017 17:00",
        "value": 1
    },
    {
        "date": "12/07/2017 18:00",
        "value": 1
    },
    {
        "date": "12/07/2017 19:00",
        "value": 1
    },
    {
        "date": "12/07/2017 20:00",
        "value": 1
    },
    {
        "date": "12/07/2017 21:00",
        "value": 1
    },
    {
        "date": "12/07/2017 22:00",
        "value": 1
    },
    {
        "date": "12/07/2017 23:00",
        "value": 1
    },
    {
        "date": "12/08/2017 00:00",
        "value": 1
    },
    {
        "date": "12/08/2017 01:00",
        "value": 1
    },
    {
        "date": "12/08/2017 02:00",
        "value": 1
    },
    {
        "date": "12/08/2017 03:00",
        "value": 1
    },
    {
        "date": "12/08/2017 04:00",
        "value": 1
    },
    {
        "date": "12/08/2017 05:00",
        "value": 1
    },
    {
        "date": "12/08/2017 06:00",
        "value": 1
    },
    {
        "date": "12/08/2017 07:00",
        "value": 1
    },
    {
        "date": "12/08/2017 08:00",
        "value": 1
    },
    {
        "date": "12/08/2017 09:00",
        "value": 1
    },
    {
        "date": "12/08/2017 10:00",
        "value": 1
    },
    {
        "date": "12/08/2017 11:00",
        "value": 1
    },
    {
        "date": "12/08/2017 12:00",
        "value": 1
    },
    {
        "date": "12/08/2017 13:00",
        "value": 1
    },
    {
        "date": "12/08/2017 14:00",
        "value": 1
    },
    {
        "date": "12/08/2017 15:00",
        "value": 1
    },
    {
        "date": "12/08/2017 16:00",
        "value": 1
    },
    {
        "date": "12/08/2017 17:00",
        "value": 1
    },
    {
        "date": "12/08/2017 18:00",
        "value": 1
    },
    {
        "date": "12/08/2017 19:00",
        "value": 1
    },
    {
        "date": "12/08/2017 20:00",
        "value": 1
    },
    {
        "date": "12/08/2017 21:00",
        "value": 1
    },
    {
        "date": "12/08/2017 22:00",
        "value": 1
    },
    {
        "date": "12/08/2017 23:00",
        "value": 1
    },
    {
        "date": "12/09/2017 00:00",
        "value": 1
    },
    {
        "date": "12/09/2017 01:00",
        "value": 1
    },
    {
        "date": "12/09/2017 02:00",
        "value": 1
    },
    {
        "date": "12/09/2017 03:00",
        "value": 1
    },
    {
        "date": "12/09/2017 04:00",
        "value": 1
    },
    {
        "date": "12/09/2017 05:00",
        "value": 1
    },
    {
        "date": "12/09/2017 06:00",
        "value": 1
    },
    {
        "date": "12/09/2017 07:00",
        "value": 1
    },
    {
        "date": "12/09/2017 08:00",
        "value": 1
    },
    {
        "date": "12/09/2017 09:00",
        "value": 1
    },
    {
        "date": "12/09/2017 10:00",
        "value": 1
    },
    {
        "date": "12/09/2017 11:00",
        "value": 1
    },
    {
        "date": "12/09/2017 12:00",
        "value": 1
    },
    {
        "date": "12/09/2017 13:00",
        "value": 1
    },
    {
        "date": "12/09/2017 14:00",
        "value": 1
    },
    {
        "date": "12/09/2017 15:00",
        "value": 1
    },
    {
        "date": "12/09/2017 16:00",
        "value": 1
    },
    {
        "date": "12/09/2017 17:00",
        "value": 1
    },
    {
        "date": "12/09/2017 18:00",
        "value": 1
    },
    {
        "date": "12/09/2017 19:00",
        "value": 1
    },
    {
        "date": "12/09/2017 20:00",
        "value": 1
    },
    {
        "date": "12/09/2017 21:00",
        "value": 1
    },
    {
        "date": "12/09/2017 22:00",
        "value": 1
    },
    {
        "date": "12/09/2017 23:00",
        "value": 1
    },
    {
        "date": "12/10/2017 00:00",
        "value": 1
    },
    {
        "date": "12/10/2017 01:00",
        "value": 1
    },
    {
        "date": "12/10/2017 02:00",
        "value": 1
    },
    {
        "date": "12/10/2017 03:00",
        "value": 1
    },
    {
        "date": "12/10/2017 04:00",
        "value": 1
    },
    {
        "date": "12/10/2017 05:00",
        "value": 1
    },
    {
        "date": "12/10/2017 06:00",
        "value": 1
    },
    {
        "date": "12/10/2017 07:00",
        "value": 1
    },
    {
        "date": "12/10/2017 08:00",
        "value": 1
    },
    {
        "date": "12/10/2017 09:00",
        "value": 1
    },
    {
        "date": "12/10/2017 10:00",
        "value": 1
    },
    {
        "date": "12/10/2017 11:00",
        "value": 1
    },
    {
        "date": "12/10/2017 12:00",
        "value": 1
    },
    {
        "date": "12/10/2017 13:00",
        "value": 1
    },
    {
        "date": "12/10/2017 14:00",
        "value": 1
    },
    {
        "date": "12/10/2017 15:00",
        "value": 1
    },
    {
        "date": "12/10/2017 16:00",
        "value": 1
    },
    {
        "date": "12/10/2017 17:00",
        "value": 1
    },
    {
        "date": "12/10/2017 18:00",
        "value": 1
    },
    {
        "date": "12/10/2017 19:00",
        "value": 1
    },
    {
        "date": "12/10/2017 20:00",
        "value": 1
    },
    {
        "date": "12/10/2017 21:00",
        "value": 1
    },
    {
        "date": "12/10/2017 22:00",
        "value": 1
    },
    {
        "date": "12/10/2017 23:00",
        "value": 1
    },
    {
        "date": "12/11/2017 00:00",
        "value": 1
    },
    {
        "date": "12/11/2017 01:00",
        "value": 1
    },
    {
        "date": "12/11/2017 02:00",
        "value": 1
    },
    {
        "date": "12/11/2017 03:00",
        "value": 1
    },
    {
        "date": "12/11/2017 04:00",
        "value": 1
    },
    {
        "date": "12/11/2017 05:00",
        "value": 1
    },
    {
        "date": "12/11/2017 06:00",
        "value": 1
    },
    {
        "date": "12/11/2017 07:00",
        "value": 1
    },
    {
        "date": "12/11/2017 08:00",
        "value": 1
    },
    {
        "date": "12/11/2017 09:00",
        "value": 1
    },
    {
        "date": "12/11/2017 10:00",
        "value": 1
    },
    {
        "date": "12/11/2017 11:00",
        "value": 1
    },
    {
        "date": "12/11/2017 12:00",
        "value": 1
    },
    {
        "date": "12/11/2017 13:00",
        "value": 1
    },
    {
        "date": "12/11/2017 14:00",
        "value": 1
    },
    {
        "date": "12/11/2017 15:00",
        "value": 1
    },
    {
        "date": "12/11/2017 16:00",
        "value": 1
    },
    {
        "date": "12/11/2017 17:00",
        "value": 1
    },
    {
        "date": "12/11/2017 18:00",
        "value": 1
    },
    {
        "date": "12/11/2017 19:00",
        "value": 1
    },
    {
        "date": "12/11/2017 20:00",
        "value": 1
    },
    {
        "date": "12/11/2017 21:00",
        "value": 1
    },
    {
        "date": "12/11/2017 22:00",
        "value": 1
    },
    {
        "date": "12/11/2017 23:00",
        "value": 1
    },
    {
        "date": "12/12/2017 00:00",
        "value": 1
    },
    {
        "date": "12/12/2017 01:00",
        "value": 1
    },
    {
        "date": "12/12/2017 02:00",
        "value": 1
    },
    {
        "date": "12/12/2017 03:00",
        "value": 1
    },
    {
        "date": "12/12/2017 04:00",
        "value": 1
    },
    {
        "date": "12/12/2017 05:00",
        "value": 1
    },
    {
        "date": "12/12/2017 06:00",
        "value": 1
    },
    {
        "date": "12/12/2017 07:00",
        "value": 1
    },
    {
        "date": "12/12/2017 08:00",
        "value": 1
    },
    {
        "date": "12/12/2017 09:00",
        "value": 1
    },
    {
        "date": "12/12/2017 10:00",
        "value": 1
    },
    {
        "date": "12/12/2017 11:00",
        "value": 1
    },
    {
        "date": "12/12/2017 12:00",
        "value": 1
    },
    {
        "date": "12/12/2017 13:00",
        "value": 1
    },
    {
        "date": "12/12/2017 14:00",
        "value": 1
    },
    {
        "date": "12/12/2017 15:00",
        "value": 1
    },
    {
        "date": "12/12/2017 16:00",
        "value": 1
    },
    {
        "date": "12/12/2017 17:00",
        "value": 1
    },
    {
        "date": "12/12/2017 18:00",
        "value": 1
    },
    {
        "date": "12/12/2017 19:00",
        "value": 1
    },
    {
        "date": "12/12/2017 20:00",
        "value": 1
    },
    {
        "date": "12/12/2017 21:00",
        "value": 1
    },
    {
        "date": "12/12/2017 22:00",
        "value": 1
    },
    {
        "date": "12/12/2017 23:00",
        "value": 1
    },
    {
        "date": "12/13/2017 00:00",
        "value": 1
    },
    {
        "date": "12/13/2017 01:00",
        "value": 1
    },
    {
        "date": "12/13/2017 02:00",
        "value": 1
    },
    {
        "date": "12/13/2017 03:00",
        "value": 1
    },
    {
        "date": "12/13/2017 04:00",
        "value": 1
    },
    {
        "date": "12/13/2017 05:00",
        "value": 1
    },
    {
        "date": "12/13/2017 06:00",
        "value": 1
    },
    {
        "date": "12/13/2017 07:00",
        "value": 1
    },
    {
        "date": "12/13/2017 08:00",
        "value": 1
    },
    {
        "date": "12/13/2017 09:00",
        "value": 1
    },
    {
        "date": "12/13/2017 10:00",
        "value": 1
    },
    {
        "date": "12/13/2017 11:00",
        "value": 1
    }
]
*/
/*
const data2 = [{
    "date": "03/29/2017 10:00",
    "values": [2, 1, 3]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [3, 3, 1]
}, {
    "date": "03/29/2017 13:00",
    "values": [4, 5, 3]
}];
*/
const names = ["Label 1", "Label 2", "Label 3"]

//const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];


class TimelineSample extends React.Component {
    constructor() {
        super();
        this._onTimeRangeChange = this._onTimeRangeChange.bind(this);
        this._onPrev = this._onPrev.bind(this);
        this._onPause = this._onPause.bind(this);
        this._onNext = this._onNext.bind(this);
        this._onLast = this._onLast.bind(this);
        this.state = ({ data: data2 })
    }
    _onTimeRangeChange(event) {
        console.log(event);
    }
    _onPrev(event) {
        console.log(event);
    }
    _onPause(event) {
        console.log(event);
    }
    _onNext(event) {
        console.log(event);
    }
    _onLast(event) {
        console.log(event);
    }
    render() {
        return (
            <div><br /><br />
                <dnx-ttt-ttt data={'data2'} test={'test2'}></dnx-ttt-ttt>
                <DnxTimelineS
                    data={data1}
                    collapsed={false}
                    sliders={false}
                    minPeriod={"5mm"}
                    exprt={false}
                ></DnxTimelineS><br /><br />
                <DnxTimelineS
                    data={data1}
                    collapsed={false}
                    sliders={false}
                    minPeriod={"5mm"}
                    exprt={false}
                ></DnxTimelineS><br /><br />
                <div>Timeline Slider Option 1</div>
                <DnxTimelineS
                    data={this.state.data}
                    collapsed={false}
                    sliders={true}
                    onTimeRangeChange={this._onTimeRangeChange}
                    onPrev={this._onPrev}
                    onPause={this._onPause}
                    onNext={this._onNext}
                    onLast={this._onLast}
                    minperiod={"5mm"}
                    linevisibility={false}
                    period={'24h'}
                    exprt={false}
                ></DnxTimelineS><br /><br />
                <DnxBar
                    data={data}
                    names={names}
                    topValue={[4, 5, 4, 5]}
                    bottomValue={[1, 2, 1, 2]}
                    topname={'XXXXXXXXXXX'}
                    bottomname={'XXXXXXXXXXX'}
                    rotate={false}
                    stack={'regular'}
                    xformat={'date'}
                    xtitle={'Time'}
                    ytitle={'Title for Y'}
                    exprt={false}
                ></DnxBar>
            </div>
        );
    }
}

export default TimelineSample;
`

export const src = `
    //import {html, render} from 'lit-html';

    //console.log(html)
    // This is a lit-html template function. It returns a lit-html template.
    //const helloTemplate = (name) => html"<div>Hello {name}!</div>";

    // This renders <div>Hello Steve!</div> to the document body
    //render(helloTemplate('Steve'), document.body);

	const template = "<donut-everywhere></donut-everywhere>";
    const data = [{date: "Hoy", value: 12}]
    console.log(data)
    document.onreadystatechange = () => {
        if (document.readyState === "complete") {
            const sampleCode  = document.querySelector("._sampleDomElement");
            console.log(sampleCode)
            sampleCode.innerHTML = template
        }
    }
`


// WEBPACK FOOTER //
// ./src/samples/TimelineHomeReact.js